import React from "react";

// ชื่อนักเรียนตามภาษาที่เลือกบนเมนูภาคศาสนา (LanguageContext) — โหมดยาวี/อาหรับ
// แสดงชื่ออาหรับ เพราะครูที่สลับเมนูเป็นอาหรับอ่านรายชื่อภาษาไทยปนอยู่แถวเดียวไม่ไหว
//
// นักเรียนที่ยังไม่ได้กรอกชื่ออาหรับตกกลับเป็นชื่อไทย — ปล่อยว่างแล้วครูจะไม่รู้ว่า
// แถวนั้นเป็นใคร ซึ่งแย่กว่าชื่อผิดภาษา
export const hasArabicName = (student, lang) => lang !== 'th' && !!student?.st_arabicname;

export const studentDisplayName = (student, lang) =>
  hasArabicName(student, lang) ? student.st_arabicname : (student?.st_name || '');

// .arabic-text มีผลเฉพาะตอน html มีคลาส islamic-rtl (ดู scss/islamic-rtl.scss)
// ใส่เฉพาะตอนที่ข้อความเป็นอาหรับจริง ชื่อไทยที่ตกกลับมาจะได้ไม่โดนฟอนต์อาหรับ
export const StudentName = ({ student, lang, className = '' }) => {
  const arabic = hasArabicName(student, lang);
  const cls = [arabic ? 'arabic-text' : '', className].filter(Boolean).join(' ');
  return (
    <span className={cls || undefined} lang={arabic ? 'ar' : undefined}>
      {studentDisplayName(student, lang)}
    </span>
  );
};

export default StudentName;
